import type { ITokenApi } from "../../application/interfaces/ITokenApi";
import type { IdpDto } from "../../shared/IdpDto";
import type { TokenDto } from "../../shared/TokenDto";
import type { IAppConfigProvider } from "../../application/interfaces/IAppConfigProvider";

export class TokenApi implements ITokenApi {
  readonly configProvider: IAppConfigProvider;

  constructor(configProvider: IAppConfigProvider) {
    this.configProvider = configProvider;
  }

  async getIdp(): Promise<IdpDto> {
    const config = await this.configProvider.getAppConfig();
    const headers: Record<string, string> = {
      "X-Api-Key": config.apiKey,
    };

    const url = `${config.apiUrl}/Idp`;
    const response = await fetch(url, {
      headers,
    });
    return (await response.json()) as IdpDto;
  }

  async getTokenForCode(code: string): Promise<TokenDto> {
    const config = await this.configProvider.getAppConfig();
    const headers: Record<string, string> = {
      "X-Api-Key": config.apiKey,
      "Content-Type": "application/json",
    };

    const url = `${config.apiUrl}/Token`;
    const response = await fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify({ code: code }),
    });
    if (response.ok) {
      return (await response.json()) as TokenDto;
    } else {
      throw new Error(
        `Fehler beim Login (Token): HTTP ${response.status} ${response.statusText}`,
      );
    }
  }

  async getTokenForRefreshToken(currentAccessToken: string): Promise<TokenDto> {
    const config = await this.configProvider.getAppConfig();
    const headers: Record<string, string> = {
      "X-Api-Key": config.apiKey,
      "Content-Type": "application/json",
    };

    const url = `${config.apiUrl}/RefreshToken`;
    const response = await fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify({
        "currentAccessToken": currentAccessToken
      }),
    });
    if (response.ok) {
      return (await response.json()) as TokenDto;
    } else {
      throw new Error(
        `Failed refresh Token: HTTP ${response.status} ${response.statusText}`,
      );
    }
  }
}
